import {FilterDef, HTTPGenericResponse} from "../../constants/FinanceModels";
import {useApi} from "../Api";
import {
    ID_FILTER_CUSTOMERNAME_TS,
    ID_FILTER_PERCENTAGE_FROM_TS,
    ID_FILTER_PERCENTAGE_TO_TS,
    ID_FILTER_SEARCH_TS, ID_FILTER_THRESHOLD_DEALERS,
    ID_FILTER_THRESHOLD_FROM_TS, ID_FILTER_THRESHOLD_LEGAL_ENTITIES,
    ID_FILTER_THRESHOLD_TO_TS,
    ID_FILTER_TYPOLOGY_TS
} from "../../pages/cashback/constants/ThresholdsConstants";
import {
    ID_FILTER_ACCRUED_FROM_LM,
    ID_FILTER_ACCRUED_TO_LM,
    ID_FILTER_CUSTOMERNAME_LM,
    ID_FILTER_DATE_FROM_LM,
    ID_FILTER_DATE_TO_LM,
    ID_FILTER_DEALERS,
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_PERCENTAGE_FROM_LM,
    ID_FILTER_PERCENTAGE_TO_LM,
    ID_FILTER_SEARCH_LM,
    ID_FILTER_THRESHOLD_FROM_LM,
    ID_FILTER_THRESHOLD_TO_LM,
    ID_FILTER_TYPOLOGY_LM
} from "../../pages/cashback/constants/LiveMonitoringConstants";

import {getFilterValue} from "../../utils/FilterUtils";
import qs from "qs";
import {fixThresholdValue, offsetDateJsConvert} from "../../pages/cashback/util/CashbackUtil";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useCashBackRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/cashback";
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    function getThreshold(offset: number | null, limit: number | null , sortBy: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<any> {
        let legalEntities: string[] = getFilterValue(ID_FILTER_THRESHOLD_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_THRESHOLD_DEALERS, filterDefs);
        let params = {
            offset: offset, 
            limit: limit,
            sortBy: sortBy,
            order: order,
            search:  getFilterValue(ID_FILTER_SEARCH_TS, filterDefs),
            typology: getFilterValue(ID_FILTER_TYPOLOGY_TS, filterDefs),
            percentageFrom: getFilterValue(ID_FILTER_PERCENTAGE_FROM_TS, filterDefs),
            percentageTo: getFilterValue(ID_FILTER_PERCENTAGE_TO_TS, filterDefs),
            thresholdFrom:  fixThresholdValue(getFilterValue(ID_FILTER_THRESHOLD_FROM_TS, filterDefs)),
            thresholdTo:  fixThresholdValue(getFilterValue(ID_FILTER_THRESHOLD_TO_TS, filterDefs)),
            customerName: getFilterValue(ID_FILTER_CUSTOMERNAME_TS, filterDefs),
            legalEntities: legalEntities,
            dealers: dealers
        }
        params.sortBy = params.sortBy == "customer-name" ? ID_FILTER_CUSTOMERNAME_TS : sortBy; 
        return GET(`${PATH}/threshold-configuration`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }
    function getFilteredThreshold(customerName: string): Promise<any> {
         let params = {
            customerName: customerName, legalEntities: allLegalEntities
        }
        return GET(`${PATH}/threshold-configuration`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    //Update a threshold configuration.
    function updateThreshold(threshold: any){
        return PUT(`${PATH}/threshold-configuration/${threshold.id}`, threshold, {}, true);
    }

    function postThresholds(thresholds: any){
        return POST(`${PATH}/threshold-configuration`, thresholds, {}, true);
    }

    function deleteThreshold(thresholdId: number): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/threshold-configuration/${thresholdId}`);
    }


    //Retrieve a list of all bonus cashback
    function getLiveMonitoring( offset: number, limit: number, sortBy: string | null, order: string | null,  filterDefs: FilterDef[] = [], dateFrom: string | "" , dateTo: string | ""): Promise<any> {
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);
        let params = {
            offset: offset,
            limit: limit,
            sortBy: sortBy,
            order: order,
            dateFrom: getFilterValue(ID_FILTER_DATE_FROM_LM , filterDefs) ? getFilterValue(ID_FILTER_DATE_FROM_LM , filterDefs) : offsetDateJsConvert(dateFrom, 'DD/MM/YYYY'),
            dateTo: getFilterValue(ID_FILTER_DATE_TO_LM , filterDefs) ? getFilterValue(ID_FILTER_DATE_TO_LM , filterDefs) : offsetDateJsConvert(dateTo, 'DD/MM/YYYY'),
            search:  getFilterValue(ID_FILTER_SEARCH_LM , filterDefs),
            typology: getFilterValue(ID_FILTER_TYPOLOGY_LM , filterDefs),
            percentageFrom: getFilterValue(ID_FILTER_PERCENTAGE_FROM_LM , filterDefs),
            percentageTo: getFilterValue(ID_FILTER_PERCENTAGE_TO_LM , filterDefs),
            thresholdFrom:  fixThresholdValue(getFilterValue(ID_FILTER_THRESHOLD_FROM_LM , filterDefs)),
            thresholdTo:  fixThresholdValue(getFilterValue(ID_FILTER_THRESHOLD_TO_LM , filterDefs)),
            accruedAmountFrom:  fixThresholdValue(getFilterValue(ID_FILTER_ACCRUED_FROM_LM , filterDefs)),
            accruedAmountTo:  fixThresholdValue(getFilterValue(ID_FILTER_ACCRUED_TO_LM , filterDefs)),
            customerName: getFilterValue(ID_FILTER_CUSTOMERNAME_LM , filterDefs),
            legalEntities: legalEntities,
            dealers: dealers
        }
  
        return GET(`${PATH}/bonus-cashback`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }


    function getLiveMonitoringNotes(sapId: number) : Promise<any> {
        return GET(`${PATH}/customer-note/customer/${sapId}`);
    }

    function postLiveMonitoringNotes(sapId: number, notes: any) : Promise<any> {
        return POST(`${PATH}/customer-note/customer/${sapId}`, notes, {}, true);
    }


    return { getThreshold, getFilteredThreshold, updateThreshold, deleteThreshold, postThresholds, getLiveMonitoring, getLiveMonitoringNotes, postLiveMonitoringNotes};

}